import { useState, useRef } from 'react'
import { Button } from 'UI/Button/Button'
import { InputFile } from 'UI/InputFile/InputFile'
import { createSupportTicket, FileData } from 'services/api'
import { useTranslation } from 'react-i18next'

interface ModalUploadReceiptProps {
  orderId: string
  timeRemaining: number
  onClose?: () => void
  goTo?: () => void
}

export const ModalUploadReceipt = ({
  orderId, 
  timeRemaining,
  onClose, 
  goTo
}: ModalUploadReceiptProps) => {
  const { t } = useTranslation()
  const [isDisabled, setIsDisabled] = useState(true)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string>('')
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleSubmit = async () => {
    const fileInput = document.getElementById('file-drop') as HTMLInputElement
    
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
      setError(t("Пожалуйста, загрузите скриншот оплаты"))
      return
    }

    setLoading(true)
    setError('')

    try {
      const file = fileInput.files[0]
      
      // Convert file to base64
      const reader = new FileReader()
      reader.onload = async () => {
        try {
          const fileData: FileData = {
            name: file.name,
            type: file.type,
            data: reader.result as string
          }

          await createSupportTicket(orderId, fileData, timeRemaining)
          
          if (goTo) goTo()
        } catch (error) {
          console.error('Upload error:', error)
          setError(t("Ошибка при отправке. Попробуйте еще раз."))
          setLoading(false)
        }
      }
      
      reader.onerror = () => {
        setError(t("Ошибка при чтении файла"))
        setLoading(false)
      }
      
      reader.readAsDataURL(file)
    } catch (error) {
      console.error('Upload error:', error)
      setError(t("Ошибка при отправке. Попробуйте еще раз."))
      setLoading(false)
    }
  }

  return (
    <>
      <p>{t("Загрузите скриншот оплаты")}</p>
      <div style={{ margin: '20px 0' }}>
        <InputFile setIsDisabledFiles={setIsDisabled} />
      </div>
      {error && (
        <p style={{ color: '#FF4444', fontSize: '14px', marginBottom: '10px' }}>
          {error}
        </p>
      )}
      <Button 
        variant='yellow' 
        onClick={handleSubmit}
        disabled={isDisabled || loading}
      >
        {loading ? t("Отправка...") : t("Подтвердить")}
      </Button>
      <Button onClick={onClose} variant='outline' disabled={loading}>
        {t("Отмена")}
      </Button>
    </>
  )
}

